import { render, staticRenderFns } from "./Review.v2.vue?vue&type=template&id=c8e0c9b6&scoped=true&"
import script from "./Review.v2.vue?vue&type=script&lang=js&"
export * from "./Review.v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e0c9b6",
  null
  
)

export default component.exports